import BaseModule from '../../../javascripts/helpers/baseModule';

export default class Standard extends BaseModule {
  constructor(element) {
    super(element, 'top-btn');
  }

  // triggered  once in BaseModule
  init() {
    this.elements.self.addEventListener('click', (event) => {
      event.preventDefault();
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
}
